module.exports = "<button type=\"button\" class=\"btn-icon\" [ngClass]=\"action.cssClass\" [disabled]=\"action.disabled\" [hidden]=\"action.hidden\" (click)=\"action.onClick()\" [title]=\"action.title\" *ngFor=\"let action of actions\">\r\n\t<span>{{action.name}}</span>\r\n</button>\r\n";


//////////////////
// WEBPACK FOOTER
// ./app/shared/components/sm-bulk-actions.component.html
// module id = 442
// module chunks = 11